import { createColumnHelper } from '@tanstack/react-table';
import { Sample } from '@texas/api/endpoints/samplesApi';
import {
  sampleColumnsCreator,
  SamplesColumnsBaseProps,
} from './sampleColumnsCreator';
import { PaIcon } from '@texas/components/shared/productApproval/PaIcon';
import { compareEnum } from '@texas/utils/helpers/enumHelpers';
import { ProductApprovalState } from '@texas/api/endpoints/productApprovalsApi';

export const samplesReceivedAtBrandColumns = (
  props: SamplesColumnsBaseProps,
) => {
  const columnHelper = createColumnHelper<Sample>();
  const columns = [
    columnHelper.accessor('productApproval.state', {
      cell: (info) => {
        return (
          <>
            {compareEnum(
              ProductApprovalState,
              info.getValue(),
              ProductApprovalState.OnHold,
            ) && <PaIcon state={info.getValue()} />}
          </>
        );
      },
      header: props.t('sample.onHold'),
      maxSize: 100,
      meta: { toggleable: true, defaultVisible: true },
    }),
  ];

  return sampleColumnsCreator({
    t: props.t,
    columns: { afterIndex: 7, columns },
    hideStopFollowing: props.hideStopFollowing,
  });
};
